import { useState, useCallback } from 'react';
import useAttributesAllergensApi from './useAttributesAllergensApi';
import { MasterAttribute, AttributeUsageEntry } from '../types';

const useAttributeDetail = () => {
  const { getAttributeDetail, getAttributeUsage } = useAttributesAllergensApi();
  const [attribute, setAttribute] = useState<MasterAttribute | null>(null);
  const [usage, setUsage] = useState<AttributeUsageEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadAttribute = useCallback(async (code: string) => {
    setIsLoading(true);
    setError(null);
    try {
      const [detail, usageEntries] = await Promise.all([
        getAttributeDetail(code),
        getAttributeUsage(code),
      ]);
      setAttribute(detail);
      setUsage(usageEntries);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load attribute');
      setAttribute(null);
      setUsage([]);
    } finally {
      setIsLoading(false);
    }
  }, [getAttributeDetail, getAttributeUsage]);

  return { attribute, usage, isLoading, error, loadAttribute };
};

export default useAttributeDetail;
